import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.scss";
import "./firebase";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import RootProvider from "./providers/RootProvider";

ReactDOM.render(
  <React.StrictMode>
    <RootProvider>
      <App />
    </RootProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
